import { withSentryWrapper } from '../ErrorBoundary';
import { PaymentMethodsBanner } from './controller';

export const PaymentMethodsBannerRoot = withSentryWrapper(PaymentMethodsBanner);
